import { render, staticRenderFns } from "./SchoolListsBaseFormHeader.vue?vue&type=template&id=cd9daa62"
import script from "./SchoolListsBaseFormHeader.vue?vue&type=script&lang=js"
export * from "./SchoolListsBaseFormHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports